exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".beng-logs .settings{margin-bottom:16px}.beng-logs .settings md-divider{margin-top:10px}.k-animation-container .k-button{border:0}.brd-log-dialog-container{min-width:500px}.brd-log-dialog-container .change-password{margin-right:24px}.brd-log-password-container .title{padding-left:16px;padding-right:128px}.brd-log-dialog-container .log-mode,.brd-log-password-container .form{margin:16px;margin-left:24px}.brd-log-dialog-container .actions,.brd-log-password-container .actions{margin:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./app/beng-logs/beng-logs.less
// module id = ./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/beng-logs/beng-logs.less
// module chunks = 8